import React, { useRef, useState, useEffect } from 'react';
import './trending.scss'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Box, Container, Grid, Link } from '@mui/material';
function TrendingPage() {
const steps = [
    {
      id: "01",
      icon: "fa fa-mobile",
      title: "STEP ",
      description:
        "Open the Mandirwiki app and select the video you would like to watch.",
    },
    {
      id: "02",
      icon: "fa fa-mobile",
      title: "STEP",
      description:
        "Place your phone inside the VR headset.",
    },
    {
      id: "03",
      icon: "fa fa-headphones",
      title: "STEP",
      description:
        "If the image appears blurry, use the adjustment wheel on the VR headset to adjust the lenses until the view is clear.",
    },
  ];  
   const vrShowData = [
  { id: 1, title: "DWARKA BENEATH THE SEA", image: "/assets/trending/sea.webp" },
  { id: 2, title: "VARANASI AFTER SUNSET", image: "/assets/trending/varanasi.webp" },
  { id: 3, title: "KASHI", image: "/assets/trending/varanasi.webp" },
  { id: 4, title: "MANIKARNIKA", image: "/assets/trending/manikarna.webp" },
];

const dData = [
  { id: 1, title: "THE LAST MOMENTS OF LORD KRISHNA", image: "/assets/trending/krishna.webp" },
  { id: 2, title: "JAGANNATH PURI", image: "/assets/trending/jaganath-puri.webp" },
  { id: 3, title: "KEDARNATH", image: "/assets/trending/kedarnath2.webp" },
  { id: 4, title: "BHIM SHILA", image: "/assets/trending/bhimshila.webp" },
  { id: 5, title: "DEOGHAR", image: "/assets/trending/deoghar.webp" },
  { id: 6, title: "VAISHNO DEVI", image: "/assets/trending/vaishno-devi.webp" },
];

const trendingData = [
  { id: 1, number: "1", title: "AYODHYA MANDIR", image: "/assets/trending/somnath.webp" },
  { id: 2, number: "2", title: "DWARKADHISH", image: "/assets/trending/mallikarjuna.webp" },
  { id: 3, number: "3", title: "KEDARNATH", image: "/assets/trending/kedarnath.webp" },
  { id: 4, number: "4", title: "BANARAS", image: "/assets/trending/somnath.webp" },
];

const JyotirlingasData = [
  { id: 1, title: "Somnath Temple", image: "/assets/trending/somnath.webp" },
  { id: 2, title: "Mallikarjuna Temple", image: "/assets/trending/mallikarjuna.webp" },
  { id: 3, title: "Mahakaleshwar Temple", image: "/assets/trending/mahakaleshwar.webp" },
  { id: 4, title: "Omkareshwar Temple", image: "/assets/trending/omkareshwar.webp" },
  { id: 5, title: "Bhimashankar Temple", image: "/assets/trending/bhimashankar.webp" },
];

const chardhamData = [
  { id: 1, title: "YAMUNOTRI", image: "/assets/trending/yamunotri.webp" },
  { id: 2, title: "GANGOTRI", image: "/assets/trending/gangotri.webp" },
  { id: 3, title: "KEDARNATH", image: "/assets/trending/kedarnath.webp" },
  { id: 4, title: "BADRINATH", image: "/assets/trending/badrinath.webp" },
];

const chotaChardhamData = [
  { id: 1, title: "BADRINATH", image: "/assets/trending/badrinath.webp" },
  { id: 2, title: "RAMESHWARAM", image: "/assets/trending/rameshwaram.webp" },
  { id: 3, title: "DWARKA", image: "/assets/trending/dwarka.webp" },
  { id: 4, title: "JAGANNATH", image: "/assets/trending/jaganath-puri.webp" },
];

const deviTempleData = [
  { id: 1, title: "Bhadrakali Temple", image: "/assets/trending/bhadrakali-temple.webp" },
  { id: 2, title: "Maa Taratarini Temple", image: "/assets/trending/maa-taratarini.webp" },
  { id: 3, title: "Vimala Temple", image: "/assets/trending/vimala.webp" },
  { id: 4, title: "Kamakhya Temple", image: "/assets/trending/kamakhya.webp" },
  { id: 4, title: "Kalighat Kali Temple", image: "/assets/trending/kalighat-kali.webp" },
  { id: 4, title: "Jwalaji Temple", image: "/assets/trending/jwalaji-temple.webp" },
];

const continueWatchingData = [
  { id: 1, title: "Nageshwar", image: "/assets/trending/demo-9.webp" },
  { id: 2, title: "Rameshwaram", image: "/assets/trending/demo-10.webp" },
  { id: 3, title: "Grishneshwar", image: "/assets/trending/demo-11.webp" },
  { id: 4, title: "Omkareshwar", image: "/assets/trending/demo-12.webp" },
];
   return (
      <>
         <Box className="trendingPage" >
            <Container maxWidth="lg">
               <Grid container spacing={2} justifyContent="left" alignItems="center">
                  <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                     <Box className="VrBannerText">
                        <span className="virtualTab">
                           Featured Darshan
                        </span>
                        <div>
                           <h1 className="mt-4">KASHI VISHWANATH</h1>
                           <p>Walk the ancient ghats of Varanasi at dawn. A cinematic journey into the eternal city of light, its aartis, alleys, and the temple at its beating heart.
                           </p>
                           <div className="d-flex gap-3 bannerButton">
                              {/* <Box className="text-center mt-lg-3">
                                 <a href="#formBox" className="btn btn-success text-dark"><i className="fa fa-play ms-1 text-dark"></i> Play </a>
                              </Box> */}
                              <Box className="text-center mt-lg-3">
                                 <a href="#threeSteps" className="btn btn-warning text-dark"><i className="fa fa-arrow-right me-1 text-dark"></i>More Info </a>
                              </Box>
                           </div>
                        </div>
                     </Box>
                  </Grid>
               </Grid>
            </Container>
         </Box>

         <section className="darkTheme">
            <Box className="trendingSection topTrendingSection">
               <Container maxWidth="lg">
                  <Grid container spacing={2} alignItems="stretch">
                     <Grid size={12}>
                        <Grid container spacing={2} alignItems="stretch">
                           <Grid size={{ xl: 12, lg: 12, md: 12, sm: 6, xs: 12 }} >
                              <div className="templeInnerHeading">
                                 <h2 className="text-start text-white">TRENDING NOW</h2>
                              </div>
                           </Grid>
                           {/* <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div class="text-lg-end">
                                 <a href="/trending-detail/" class="seeBtn">
                                    See All
                                    <i class="fa fa-arrow-right ms-2"></i>
                                 </a>
                              </div>
                           </Grid> */}
                        </Grid>
                     </Grid>
                     <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                      <Swiper
                        className="swiperCitySlider"
                        modules={[Navigation, Pagination, Autoplay]}
                        spaceBetween={20}
                        slidesPerView={4}
                        //  navigation={true}
                        autoplay={{
                           delay: 3000,
                           disableOnInteraction: false,
                        }}
                        breakpoints={{
                           0: {
                              slidesPerView: 2,
                           },
                           576: {
                              slidesPerView: 2,
                           },
                           768: {
                              slidesPerView: 3,
                           },
                           1200: {
                              slidesPerView: 4,
                           },
                        }}
                        >
                        {trendingData.map((item) => (
                           <SwiperSlide key={item.id}>
                              
                              <div className="trendBox">
                              {/* <span className="number">{item.number}</span> */}

                              <div className="templeCard">
                                 <img src={item.image} alt={item.title} />

                                 <div className="overlay"></div>

                                 <div className="content">
                                    <h5>{item.title}</h5>
                                 </div>
                              </div>
                              </div>
                              
                           </SwiperSlide>
                        ))}
                        </Swiper>
                     </Grid>
                  </Grid>
               </Container>
            </Box>
            <Box className="trendingSection">
               <Container maxWidth="lg">
                  <Grid container spacing={2} alignItems="stretch">
                     <Grid size={12}>
                        <Grid container spacing={2} alignItems="stretch">
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div className="templeInnerHeading">
                                 <h2 className="text-start text-white">360 VR Shows</h2>
                              </div>
                           </Grid>
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div class="text-lg-end">
                                 <a href="/vr-shows/" class="seeBtn">
                                    See All
                                    <i class="fa fa-arrow-right ms-2"></i>
                                 </a>
                              </div>
                           </Grid>
                        </Grid>
                     </Grid>
                     <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                       <Swiper
                           className="swiperCitySlider"
                           modules={[Navigation, Pagination, Autoplay]}
                           spaceBetween={20}
                           slidesPerView={4}
                           autoplay={{
                              delay: 3000,
                              disableOnInteraction: false,
                           }}
                           breakpoints={{
                              0: {
                                 slidesPerView: 2,
                              },
                              576: {
                                 slidesPerView: 2,
                              },
                              768: {
                                 slidesPerView: 4,
                              },
                              1200: {
                                 slidesPerView: 4,
                              },
                           }}
                           >
                           {vrShowData.map((item) => (
                              <SwiperSlide key={item.id}>
                                    
                                 <div className="templeCard">
                                 <img src={item.image} alt={item.title} />

                                 <div className="overlay"></div>

                                 <div className="cardContent">
                                    <h5>{item.title}</h5>

                                    <button>PLAY NOW</button>
                                 </div>
                                 </div>
                              </SwiperSlide>
                           ))}
                           </Swiper>
                     </Grid>
                  </Grid>


                  <Grid container spacing={2} alignItems="stretch">
                     <Grid size={12}>
                        <Grid container spacing={2} alignItems="stretch">
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div className="templeInnerHeading">
                                 <h2 className="text-start text-white">180 VR Experience</h2>
                              </div>
                           </Grid>
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div class="text-lg-end">
                                 <a href="/vr-experience/" class="seeBtn">
                                    See All
                                    <i class="fa fa-arrow-right ms-2"></i>
                                 </a>
                              </div>
                           </Grid>
                        </Grid>
                     </Grid>
                     <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                       <Swiper
                           className="swiperCitySlider"
                           modules={[Navigation, Pagination, Autoplay]}
                           spaceBetween={20}
                           slidesPerView={4}
                           autoplay={{
                              delay: 3000,
                              disableOnInteraction: false,
                           }}
                           breakpoints={{
                              0: {
                                 slidesPerView: 2,
                              },
                              576: {
                                 slidesPerView: 2,
                              },
                              768: {
                                 slidesPerView: 4,
                              },
                              1200: {
                                 slidesPerView: 4,
                              },
                           }}
                           >
                           {dData.map((item) => (
                              <SwiperSlide key={item.id}>
                                
                                 <div className="templeCard">
                                 <img src={item.image} alt={item.title} />

                                 <div className="overlay"></div>

                                 <div className="cardContent">
                                    <h5>{item.title}</h5>

                                    <button>PLAY NOW</button>
                                 </div>
                                 </div>
                                 
                              </SwiperSlide>
                           ))}
                           </Swiper>
                     </Grid>
                  </Grid>
                  
                  <Grid container spacing={2} alignItems="stretch">
                     <Grid size={12}>
                        <Grid container spacing={2} alignItems="stretch">
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div className="templeInnerHeading">
                                 <h2 className="text-start text-white">12 Jyotirlingas</h2>
                              </div>
                           </Grid>
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div class="text-lg-end">
                                 <a href="/jyotirlingas/" class="seeBtn">
                                    See All
                                    <i class="fa fa-arrow-right ms-2"></i>
                                 </a>
                              </div>
                           </Grid>
                        </Grid>
                     </Grid>
                     <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                       <Swiper
                           className="swiperCitySlider"
                           modules={[Navigation, Pagination, Autoplay]}
                           spaceBetween={20}
                           slidesPerView={4}
                           autoplay={{
                              delay: 3000,
                              disableOnInteraction: false,
                           }}
                           breakpoints={{
                              0: {
                                 slidesPerView: 2,
                              },
                              576: {
                                 slidesPerView: 2,
                              },
                              768: {
                                 slidesPerView: 4,
                              },
                              1200: {
                                 slidesPerView: 4,
                              },
                           }}
                           >
                           {JyotirlingasData.map((item) => (
                              <SwiperSlide key={item.id}>
                                 <div className="templeCard">
                                 <img src={item.image} alt={item.title} />

                                 <div className="overlay"></div>

                                 <div className="cardContent">
                                    <h5>{item.title}</h5>

                                    <button>PLAY NOW</button>
                                 </div>
                                 </div>
                              </SwiperSlide>
                           ))}
                           </Swiper>
                     </Grid>
                  </Grid>
                  
                  <Grid container spacing={2} alignItems="stretch">
                     <Grid size={12}>
                        <Grid container spacing={2} alignItems="stretch">
                           <Grid size={{ xl: 12, lg: 12, md: 12, sm: 6, xs: 12 }} >
                              <div className="templeInnerHeading">
                                 <h2 className="text-start text-white">CHOTA CHAR DHAM YATRA</h2>
                              </div>
                           </Grid>
                           {/* <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div class="text-lg-end">
                                 <a href="/trending-detail/" class="seeBtn">
                                    See All
                                    <i class="fa fa-arrow-right ms-2"></i>
                                 </a>
                              </div>
                           </Grid> */}
                        </Grid>
                     </Grid>
                     <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                        <Swiper
                              className="swiperCitySlider"
                              modules={[Navigation, Pagination, Autoplay]}
                              spaceBetween={20}
                              slidesPerView={4}
                              autoplay={{
                                 delay: 3000,
                                 disableOnInteraction: false,
                              }}
                              breakpoints={{
                                 0: {
                                    slidesPerView: 2,
                                 },
                                 576: {
                                    slidesPerView: 2,
                                 },
                                 768: {
                                    slidesPerView: 4,
                                 },
                                 1200: {
                                    slidesPerView: 4,
                                 },
                              }}
                              >
                              {chardhamData.map((item) => (
                                 <SwiperSlide key={item.id}>
                                    <div className="templeCard">
                                    <img src={item.image} alt={item.title} />

                                    <div className="overlay"></div>

                                    <div className="cardContent">
                                       <h5>{item.title}</h5>

                                       <button>PLAY NOW</button>
                                    </div>
                                    </div>
                                 </SwiperSlide>
                              ))}
                              </Swiper>
                     </Grid>
                  </Grid>



                  <Grid container spacing={2} alignItems="stretch">
                     <Grid size={12}>
                        <Grid container spacing={2} alignItems="stretch">
                           <Grid size={{ xl: 12, lg: 12, md: 12, sm: 6, xs: 12 }} >
                              <div className="templeInnerHeading">
                                 <h2 className="text-start text-white">CHAR DHAM YATRA</h2>
                              </div>
                           </Grid>
                           {/* <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div class="text-lg-end">
                                 <a href="/trending-detail/" class="seeBtn">
                                    See All
                                    <i class="fa fa-arrow-right ms-2"></i>
                                 </a>
                              </div>
                           </Grid> */}
                        </Grid>
                     </Grid>
                     <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                        <Swiper
                              className="swiperCitySlider"
                              modules={[Navigation, Pagination, Autoplay]}
                              spaceBetween={20}
                              slidesPerView={4}
                              autoplay={{
                                 delay: 3000,
                                 disableOnInteraction: false,
                              }}
                              breakpoints={{
                                 0: {
                                    slidesPerView: 2,
                                 },
                                 576: {
                                    slidesPerView: 2,
                                 },
                                 768: {
                                    slidesPerView: 4,
                                 },
                                 1200: {
                                    slidesPerView: 4,
                                 },
                              }}
                              >
                              {chotaChardhamData.map((item) => (
                                 <SwiperSlide key={item.id}>
                                    <div className="templeCard">
                                    <img src={item.image} alt={item.title} />

                                    <div className="overlay"></div>

                                    <div className="cardContent">
                                       <h5>{item.title}</h5>

                                       <button>PLAY NOW</button>
                                    </div>
                                    </div>
                                 </SwiperSlide>
                              ))}
                              </Swiper>
                     </Grid>
                  </Grid>


                  <Grid container spacing={2} alignItems="stretch">
                     <Grid size={12}>
                        <Grid container spacing={2} alignItems="stretch">
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div className="templeInnerHeading">
                                 <h2 className="text-start text-white">SHAKTI PEETHAS & DEVI TEMPLES</h2>
                              </div>
                           </Grid>
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div class="text-lg-end">
                                 <a href="/devi-temple" class="seeBtn">
                                    See All
                                    <i class="fa fa-arrow-right ms-2"></i>
                                 </a>
                              </div>
                           </Grid>
                        </Grid>
                     </Grid>
                     <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                       <Swiper
                           className="swiperCitySlider"
                           modules={[Navigation, Pagination, Autoplay]}
                           spaceBetween={20}
                           slidesPerView={4}
                           autoplay={{
                              delay: 3000,
                              disableOnInteraction: false,
                           }}
                           breakpoints={{
                              0: {
                                 slidesPerView: 2,
                              },
                              576: {
                                 slidesPerView: 2,
                              },
                              768: {
                                 slidesPerView: 4,
                              },
                              1200: {
                                 slidesPerView: 4,
                              },
                           }}
                           >
                           {deviTempleData.map((item) => (
                              <SwiperSlide key={item.id}>
                                 <div className="templeCard">
                                 <img src={item.image} alt={item.title} />

                                 <div className="overlay"></div>

                                 <div className="cardContent">
                                    <h5>{item.title}</h5>

                                    <button>PLAY NOW</button>
                                 </div>
                                 </div>
                              </SwiperSlide>
                           ))}
                           </Swiper>
                     </Grid>
                  </Grid>


                  {/* <Grid container spacing={2} alignItems="stretch">
                     <Grid size={12}>
                        <Grid container spacing={2} alignItems="stretch">
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div className="templeInnerHeading">
                                 <h2 className="text-start text-white">CONTINUE WATCHING</h2>
                              </div>
                           </Grid>
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div class="text-lg-end">
                                 <a href="/trending-detail/" class="seeBtn">
                                    See All
                                    <i class="fa fa-arrow-right ms-2"></i>
                                 </a>
                              </div>
                           </Grid>
                        </Grid>
                     </Grid>
                     <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                        <Swiper
                           className="swiperCitySlider"
                           modules={[Navigation, Pagination, Autoplay]}
                           spaceBetween={20}
                           slidesPerView={4}
                           autoplay={{
                              delay: 3000,
                              disableOnInteraction: false,
                           }}
                           breakpoints={{
                              0: {
                                 slidesPerView: 2,
                              },
                              576: {
                                 slidesPerView: 2,
                              },
                              768: {
                                 slidesPerView: 4,
                              },
                              1200: {
                                 slidesPerView: 4,
                              },
                           }}
                           >
                           {continueWatchingData.map((item) => (
                              <SwiperSlide key={item.id}>
                                
                                 <div className="templeCard">
                                 <img src={item.image} alt={item.title} />

                                 <div className="overlay"></div>

                                 <div className="cardContent">
                                    <h5>{item.title}</h5>

                                    <button>PLAY NOW</button>
                                 </div>
                                 </div>
                                 
                              </SwiperSlide>
                           ))}
                           </Swiper>
                     </Grid>
                  </Grid> */}
                  <Box className="ritualStepsSection" id="threeSteps">
               <Container maxWidth="lg">
                 <Grid container spacing={4} alignItems="center">
         
                   <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}>
                     <Box className="stepsLeft">
         
                       <span className="subTitle text-white">
                         THE RITUAL
                       </span>
         
                       <h2 >
                         THREE STEPS TO
                         <br />
                         YOUR DARSHAN.
                       </h2>
         
                       <p className="text-white">
                         No headset? No problem. Each experience is built
                         to be felt on any device, then deepened in full VR
                         when you're ready.
                       </p>
         
                     </Box>
                   </Grid>
         
                   <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }}>
                     <Box className="stepsRight">
         
                       {steps.map((item, index) => (
                         <Box className="stepCard" key={index}>
         
                           <div className="iconBox">
                             <i className={item.icon}></i>
                           </div>
         
                           <div className="content">
                             <span>{item.id}</span>
                             <h4>{item.title}</h4>
                             <p>{item.description}</p>
                           </div>
         
                         </Box>
                       ))}
         
                     </Box>
                   </Grid>
         
                 </Grid>
               </Container>
             </Box>
               </Container>
            </Box>
         </section>

         
      </>
   );
}
export default TrendingPage;